<div class="grid" [style.opacity]="ready ? 1 : 0" [class]="gridCssClass" #grid>
    <div class="grid-sizer"></div>
    <ng-content></ng-content>
</div>
